<script setup>
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import GlobalSearch from './GlobalSearch.vue';
const route=useRoute();
const mediaModal=ref(null);
const openMedia=()=>{ if(!mediaModal.value?.open) mediaModal.value?.showModal(); };
const closeDialog=dialog=>dialog?.close();
const onGlobalClick=event=>{ if(event.target.closest?.('[data-open-media]')) openMedia(); };
watch(()=>route.fullPath,()=>closeDialog(mediaModal.value));
onMounted(()=>document.addEventListener('click',onGlobalClick));
onBeforeUnmount(()=>document.removeEventListener('click',onGlobalClick));
</script>
<template><div class="site-dialogs">
  <GlobalSearch />
  <dialog ref="mediaModal" class="media-modal" id="mediaModal" @click.self="closeDialog(mediaModal)"><button class="modal-close" type="button" aria-label="إغلاق" @click="closeDialog(mediaModal)"><i class="bi bi-x-lg"></i></button><div class="modal-media"><i class="bi bi-play-circle"></i><h2>محتوى السنة المرئي والمسموع</h2><p>استمع إلى قراءة صوتية لكتاب صحيح البخاري من المصدر.</p><RouterLink class="cta cta-gold" to="/media/sahih-al-bukhari-audiobook-2" @click="closeDialog(mediaModal)">عرض المادة</RouterLink></div></dialog>
</div></template>
